import { render, staticRenderFns } from "./MultiCreation.vue?vue&type=template&id=a052a694&scoped=true&"
import script from "./MultiCreation.vue?vue&type=script&lang=js&"
export * from "./MultiCreation.vue?vue&type=script&lang=js&"
import style0 from "./MultiCreation.vue?vue&type=style&index=0&id=a052a694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a052a694",
  null
  
)

export default component.exports